import $ from 'jquery/src/jquery'
import {pageScroll} from "../helpers";
export default () => {
    const nodeSelectors = {
        section: '[js-popup-2="section"]',
        popup: '[js-popup-2="container"]',
        close: '[js-popup-2="close"]',
        open: '[js-popup-2="open"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.popup)) {
            return
        }

        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                close()
            }
        })

        $(nodeSelectors.close).on('click', close)
        $(nodeSelectors.open).on('click', open)
    }

    function open() {
        pageScroll(false)
        let target = $(this).data('js-popup-2--target')
        $(target).removeClass('popup--hidden')
        $(nodeSelectors.open + '[data-js-popup-2--target="'+target+'"]').addClass('active')
    }

    function close() {
        pageScroll(true)
        $(nodeSelectors.open).removeClass('active')
        $(nodeSelectors.popup).addClass('popup--hidden')
    }

    return Object.freeze({
        init,
    })
}